import * as R from 'remeda'

import { type FiveSegment, toFiveSegmentCounts } from '~/utils'

import { type NineSegmentsTotalData } from './buildNineSegmentsTotalData'
import {
  calcFiveSegmentIndicatorCounts,
  type FiveSegmentIndicator,
} from './fiveSegments'

export type FiveSegmentsTotalData = {
  counts: Record<FiveSegment | FiveSegmentIndicator | 'total', number>
  ratios: Record<FiveSegment | FiveSegmentIndicator | 'total', number>
}

export type FiveSegmentsTotalDataInput = {
  nineSegmentsTotalData: NineSegmentsTotalData
}

export const buildFiveSegmentsTotalData = (
  input: FiveSegmentsTotalDataInput,
): FiveSegmentsTotalData => {
  const total = input.nineSegmentsTotalData.counts.total
  const fiveSegmentCounts = toFiveSegmentCounts(
    input.nineSegmentsTotalData.counts,
  )
  const counts = {
    total,
    ...fiveSegmentCounts,
    ...calcFiveSegmentIndicatorCounts(fiveSegmentCounts),
  }

  const ratios = R.mapValues(counts, (count) => count / counts.total)

  return { counts, ratios }
}
